const baseUrl = process.env.REACT_APP_BASE_URL;
export const getUrl = (path: string) => baseUrl + path;